import { StackActions, useNavigation } from '@react-navigation/native';

export interface UseNavigatorPageProp {
  replaceScreen: (parentRouteName: string, childRouteName: string | undefined) => void;
  pushScreen: (parentRouteName: string, childRouteName: string | undefined, params?: any) => void;
}

export const useNavigatorPage = (): UseNavigatorPageProp => {
  const navigation = useNavigation<any>();

  const replaceScreen = (parentRouteName: string, childRouteName: string | undefined) => {
    navigation.dispatch(
      StackActions.replace(parentRouteName, {
        screen: childRouteName
      })
    );
  };

  const pushScreen = (parentRouteName: string, childRouteName: string | undefined, params?: any) => {
    navigation.navigate(parentRouteName, {
      screen: childRouteName,
      params: params
    });
  };

  return {
    replaceScreen,
    pushScreen
  };
};
